import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Icon, Menu, Tag, Tooltip } from "antd";
import { Link } from "react-router-dom";
import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";
import Auxiliary from "util/Auxiliary";

import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE
} from "../../constants/ThemeSetting";
import IntlMessages from "../../util/IntlMessages";
import { sanitizeFieldName } from "../../util/methods";
import AccessControl from "../../components/AccessControl";
import { fetchAppVersion } from "../../appRedux/actions";

const { SubMenu } = Menu;

const moduleIconMap = {
  // Main sections

  Home: { type: 'home', color: '#1d39c4' },
  Report: { type: 'bar-chart', color: '#08979c' },
  Favourite: { type: 'star', color: '#fadb14' },

  // Parent/Category icons
  AssetMaintenance: { type: 'tool', color: '#fa8c16' },
  AssetMovement: { type: 'swap', color: '#13c2c2' },
  Masters: { type: 'database', color: '#531dab' },
  SecurityAndControl: { type: 'safety', color: '#cf1322' },
  NotificationSystem: { type: 'notification', color: '#eb2f96' },
  ScheduleMaintenance: { type: 'schedule', color: '#2f54eb' },
  UserActivity: { type: 'audit', color: '#0050b3' },

  // Module specific icons
  Asset: { type: 'database', color: '#2f54eb' },
  PurchaseOrder: { type: 'shopping-cart', color: '#389e0d' },
  AssetStockTaking: { type: 'solution', color: '#d48806' },
  AssetConditionVoucher: { type: 'safety-certificate', color: '#08979c' },
  SpareStockTaking: { type: 'form', color: '#fa8c16' },
  SparesReconciliation: { type: 'audit', color: '#1890ff' },
  JobCard: { type: 'profile', color: '#0050b3' },
  Complaint: { type: 'warning', color: '#faad14' },
  PreVerification: { type: 'check-circle', color: '#52c41a' },
  ManpowerPerformance: { type: 'team', color: '#722ed1' },
  Document: { type: 'file', color: '#595959' },
  SparePart: { type: 'tool', color: '#fa541c' },
  Fuel: { type: 'fire', color: '#cf1322' },
  FuelAdjustment: { type: 'sliders', color: '#d4380d' },
  Leasing: { type: 'dollar', color: '#237804' },
  Maintenance: { type: 'setting', color: '#ad6800' },
  Inventory: { type: 'inbox', color: '#1890ff' },
  User: { type: 'user', color: '#13c2c2' },
  Role: { type: 'lock', color: '#cf1322' },
  SaleOrder: { type: 'shopping-cart', color: '#389e0d' },
  AssetTransferAdvice: { type: 'swap', color: '#13c2c2' },
  AssetReceiptNote: { type: 'inbox', color: '#2f54eb' },
  SpareTransferAdvice: { type: 'swap', color: '#13c2c2' },
  SpareReceiptAdvise: { type: 'inbox', color: '#2f54eb' },
  Vendor: { type: 'shop', color: '#389e0d' },
  AssetType: { type: 'appstore', color: '#531dab' },
  AssetMake: { type: 'tool', color: '#ad6800' },
  AssetModel: { type: 'appstore', color: '#722ed1' },
  EquipmentSubType: { type: 'branches', color: '#0050b3' },
  PointOfInterest: { type: 'environment', color: '#13c2c2' },
  IotDevice: { type: 'line-chart', color: '#2f54eb' },
  IotSupportJobs: { type: 'dashboard', color: '#2f54eb' },

  // Additional modules
  Dashboard: { type: 'dashboard', color: '#1d39c4' },
  Settings: { type: 'setting', color: '#8c8c8c' },
  Reports: { type: 'area-chart', color: '#08979c' },
  Analytics: { type: 'line-chart', color: '#531dab' },
  Calendar: { type: 'calendar', color: '#eb2f96' },
  Tasks: { type: 'check-square', color: '#52c41a' },
  Messages: { type: 'message', color: '#2f54eb' },
  Notifications: { type: 'bell', color: '#fa8c16' },
  Search: { type: 'search', color: '#595959' },
  // Upload: 'upload',
  // Download: 'download',
  // Print: 'printer',
  // Export: 'export',
  // Import: 'import',
  // Filter: 'filter',
  // Sort: 'sort-ascending',
  // Edit: 'edit',
  // Delete: 'delete',
  // Add: 'plus-circle',
  // Save: 'save',
  // Cancel: 'close-circle',
  // Refresh: 'reload',
  // More: 'ellipsis',
  // Menu: 'menu',
  // List: 'ordered-list',
  // Grid: 'appstore',
  // Table: 'table',
  // Chart: 'pie-chart',
  // Map: 'environment',
  // Location: 'environment-o',
  // Time: 'clock-circle',
  // Date: 'calendar',
  // Phone: 'phone',
  // Email: 'mail',
  // Link: 'link',
  // Attachment: 'paper-clip',
  // Image: 'picture',
  // Video: 'video-camera',
  // Audio: 'sound',
  // File: 'file',
  // Folder: 'folder',
  // Cloud: 'cloud',
  // Server: 'cluster',
  // Database: 'database',
  // Code: 'code',
  // Terminal: 'console',
  // Bug: 'bug',
  // Info: 'info-circle',
  // Warning: 'warning',
  // Error: 'close-circle',
  // Success: 'check-circle',
  // Help: 'question-circle',
  // Support: 'customer-service',
  // Feedback: 'form',
  // Rating: 'star',
  // Like: 'like',
  // Dislike: 'dislike',
  // Heart: 'heart',
  // Eye: 'eye',
  // Lock: 'lock',
  // Unlock: 'unlock',
  // Key: 'key',
  // Flag: 'flag',
  // Tag: 'tag',
  // Tags: 'tags',
  // Bookmark: 'book',
  // Bookmarks: 'bars',
  // Category: 'appstore',
  // Categories: 'apartment',
  // Group: 'team',
  // Groups: 'cluster',
  // Share: 'share-alt',
  // Send: 'send',
  // Receive: 'select',
  // Forward: 'forward',
  // Backward: 'backward',
  // Up: 'up',
  // Down: 'down',
  // Left: 'left',
  // Right: 'right',
  // Expand: 'fullscreen',
  // Collapse: 'fullscreen-exit',
  // Zoom: 'zoom-in',
  // Move: 'drag',
  // Resize: 'arrows-alt',
  // Rotate: 'reload',
  // Copy: 'copy',
  // Paste: 'snippets',
  // Cut: 'scissor',
  // Undo: 'undo',
  // Redo: 'redo'
  // Change icon for FleetTrip to use 'branches' (road/route style) instead of 'map'
  // FleetTrip: 'branches',
}

class SidebarContent extends Component {
  state = {
    activeStar: {},
    favourite: [],
    userAccess: [],
    menu: {},
  }

  adjustColorForDark = (hex) => {
    if (!hex || typeof hex !== 'string' || !hex.startsWith('#') || hex.length < 7) {
      return hex;
    }
    const value = parseInt(hex.slice(1), 16);
    if (Number.isNaN(value)) {
      return hex;
    }
    const mix = 0.4;
    const r = (value >> 16) & 255;
    const g = (value >> 8) & 255;
    const b = value & 255;
    const nr = Math.min(255, Math.round(r + (255 - r) * mix));
    const ng = Math.min(255, Math.round(g + (255 - g) * mix));
    const nb = Math.min(255, Math.round(b + (255 - b) * mix));
    const toHex = (v) => v.toString(16).padStart(2, '0');
    return `#${toHex(nr)}${toHex(ng)}${toHex(nb)}`;
  }

  componentDidMount() {
    this.props.fetchAppVersion();
    const favourite = window.localStorage.getItem('favourite');
    if (favourite) {
      this.setState({
        favourite: JSON.parse(favourite),
      })
    }

  }

  componentWillReceiveProps(nextProps, nextContext) {
    // console.log(nextProps.authUser)
    if (nextProps.authUser && JSON.stringify(nextProps.authUser) !== JSON.stringify(this.props.authUser)) {
      // console.log(nextProps.authUser)
      // this.setState({
      //   userAccess: (nextProps.authUser ? nextProps.authUser.roles : []).map((item) => {
      //     return item.access;
      //   })
      // })
    }
  }

  // componentDidUpdate() {
  // console.log(this.state.activeStar);
  // }

  getModuleIconConfig = (moduleName = '') => {
    const isDark = this.props.themeType !== THEME_TYPE_LITE;
    if (moduleIconMap[moduleName]) {
      const base = moduleIconMap[moduleName];
      return {
        ...base,
        color: isDark ? this.adjustColorForDark(base.color) : base.color
      };
    }

    const normalized = (moduleName || '').toLowerCase();
    if (normalized.includes('report')) {
      const color = '#08979c';
      return { type: 'bar-chart', color: isDark ? this.adjustColorForDark(color) : color };
    }
    if (normalized.includes('transfer') || normalized.includes('movement')) {
      const color = '#13c2c2';
      return { type: 'swap', color: isDark ? this.adjustColorForDark(color) : color };
    }
    if (normalized.includes('receipt') || normalized.includes('inward')) {
      const color = '#2f54eb';
      return { type: 'inbox', color: isDark ? this.adjustColorForDark(color) : color };
    }
    if (normalized.includes('purchase') || normalized.includes('sale') || normalized.includes('vendor')) {
      const color = '#389e0d';
      return { type: 'shopping-cart', color: isDark ? this.adjustColorForDark(color) : color };
    }
    if (normalized.includes('fuel')) {
      const color = '#cf1322';
      return { type: 'fire', color: isDark ? this.adjustColorForDark(color) : color };
    }
    if (normalized.includes('asset')) {
      const color = '#2f54eb';
      return { type: 'database', color: isDark ? this.adjustColorForDark(color) : color };
    }
    if (normalized.includes('spare')) {
      const color = '#fa541c';
      return { type: 'tool', color: isDark ? this.adjustColorForDark(color) : color };
    }
    if (normalized.includes('job')) {
      const color = '#0050b3';
      return { type: 'profile', color: isDark ? this.adjustColorForDark(color) : color };
    }
    if (normalized.includes('trip')) {
      const color = '#0050b3';
      return { type: 'branches', color: isDark ? this.adjustColorForDark(color) : color };
    }
    if (normalized.includes('user') || normalized.includes('role') || normalized.includes('security')) {
      const color = '#cf1322';
      return { type: 'safety', color: isDark ? this.adjustColorForDark(color) : color };
    }
    if (normalized.includes('billing')) {
      const color = '#389e0d';
      return { type: 'account-book', color: isDark ? this.adjustColorForDark(color) : color };
    }
    const color = '#8c8c8c';
    return { type: 'appstore', color: isDark ? this.adjustColorForDark(color) : color };
  }

  renderModuleIcon = (moduleName, style = {}) => {
    const { type, color } = this.getModuleIconConfig(moduleName);
    return <Icon type={type} style={{ color, ...style }} />;
  }

  onMouseHoverHandler = (key, isActive) => {
    const activeStar = { ...this.state.activeStar };
    activeStar[key] = !!isActive;
    this.setState({ activeStar })
  }

  handleFavourite = (linkObject, isAdded) => {
    let favourite = this.state.favourite;
    if (!!isAdded) {
      const sameObjects = favourite.filter((value, index) => {
        return JSON.stringify(linkObject) === JSON.stringify(value);
      });
      if (!sameObjects || !sameObjects.length)
        favourite.push(linkObject);
    } else {
      favourite = favourite.filter((value, index) => {
        return JSON.stringify(linkObject) !== JSON.stringify(value);
      });
    }
    this.setState({
      favourite,
    })
    // console.log(favourite);
  }

  componentWillUnmount() {
    // console.log('unmounting...');
    const favourite = this.state.favourite;
    window.localStorage.removeItem('favourite');
    window.localStorage.setItem('favourite', JSON.stringify(favourite));
  }

  getNoHeaderClass = navStyle => {
    if (
      navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR ||
      navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR
    ) {
      return "gx-no-header-notifications";
    }
    return "";
  };

  getNavStyleSubMenuClass = navStyle => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      return "gx-no-header-submenu-popup";
    }
    return "";
  };
  removeFilters = () => {
    window.localStorage.removeItem('filters');
    // console.log('Remove filters');
    // history.push('/job-card');
  }

  capitalize = function (str) {
    return str.replace(/(?:^|\s)\S/g, function (a) {
      return a.toUpperCase();
    });
  };

  hasRoleName = (roles = [], roleName) => {
    return roles.some(r => r && r.role && r.role.toLowerCase() === roleName.toLowerCase());
  }

  hasPermission = (access = [], resource, permissionNeeded, parent) => {

    // const access = this.state.userAccess;

    const rolesPermissions = access.flat(1).filter((item) => {
      return item.name === resource
    });
    const permissions = rolesPermissions.map(item => item.permissions).flat(1);

    let isEnabled = false;

    switch (permissionNeeded) {
      case 'any':
        isEnabled = permissions.length > 0;
        break;
      case 'c':
        isEnabled = permissions.indexOf('c') > -1;
        break;
      case 'u':
        isEnabled = permissions.indexOf('u') > -1;
        break;
      case 'd':
        isEnabled = permissions.indexOf('d') > -1;
        break;
      case 'r':
        isEnabled = permissions.indexOf('r') > -1;
        break;
      case 'report':
        isEnabled = permissions.indexOf('report') > -1;
        break;
      default:
        isEnabled = false;
    }
    // if (parent) {
    //   const updatedMenu = { ...this.state.menu };
    //   if (!updatedMenu[parent]) {
    //     updatedMenu[parent] = {};
    //   }
    //   updatedMenu[parent][resource] = isEnabled;
    //   this.setState( {
    //       menu: updatedMenu
    //   });
    // }
    return isEnabled;
  }

  render() {
    const { themeType, pathname, modules, authUser, app } = this.props;
    // console.log(authUser.roles && authUser.roles.length)
    const selectedKeys = this.capitalize(
      pathname
        .substr(1)
        .split("-")
        .join(" ")
    ).replace(/\s/gi, "");
    const userAccess = (authUser ? authUser.roles || [] : []).map((item) => {
      return item.access;
    })
    const permittedModules = authUser && authUser.organisation && authUser.organisation.assetProModules || []
    // console.log(permittedModules)
    // console.log(userAccess)
    const defaultOpenKeys = selectedKeys.split("/")[1];
    let menu = {};
    let menuPermissions = {};
    const allMenu = this.state.menu;
    // console.log(modules)
    modules.forEach(module => {
      if (module && module.name === 'PointOfInterest') {
        return;
      }
      const effectiveParent = module && (module.name === 'SpareStockTaking' || module.name === 'SparesReconciliation')
        ? 'AssetMovement'
        : module.parent;
      const hasPermission = this.hasPermission(userAccess, module.name, 'any', effectiveParent);
      if (!menuPermissions[effectiveParent])
        menuPermissions[effectiveParent] = [];
      menuPermissions[effectiveParent] = [...menuPermissions[effectiveParent], hasPermission];
      menu[effectiveParent] = menu[effectiveParent] || [];
      if (hasPermission) {
        menu[effectiveParent].push(
          <Menu.Item key={module.name}>
            <Tooltip mouseEnterDelay={1} title={(<i style={{ cursor: 'pointer', color: '#fadb14' }}
              className={`icon icon-star`}
              onClick={() => this.handleFavourite({
                module: 'FAV-' + module.name,
                name: sanitizeFieldName(module.modifiedName),
                link: sanitizeFieldName(module.name).toLowerCase()
                  .split(" ")
                  .join("-")
              }, true)} />)}>
              <Link
                to={`/${sanitizeFieldName(module.name)
                  .toLowerCase()
                  .split(" ")
                  .join("-")}`}
              >
                {this.renderModuleIcon(module.name)}
                <span
                  onClick={module && module.name === 'JobCard' ? () => window.localStorage.removeItem('filters') : null}>
                  {sanitizeFieldName(module.modifiedName)}{module['isBeta'] ?
                    <span style={{
                      verticalAlign: 'super',
                      fontSize: 'smaller',
                      color: 'red',
                      marginLeft: '5px'
                    }}>BETA</span> : null}</span>

              </Link>
            </Tooltip>
          </Menu.Item>
        );
      }
    });

    const canAccessSpareAdjustmentVoucherReport = this.hasPermission(userAccess, "SpareStockTaking", "r")
      || this.hasPermission(userAccess, "SparesReconciliation", "r")
      || this.hasPermission(userAccess, "SpareStockTaking", "u")
      || this.hasPermission(userAccess, "SparesReconciliation", "u")
      || this.hasPermission(userAccess, "SpareStockTaking", "c")
      || this.hasPermission(userAccess, "SparesReconciliation", "c");

    if (canAccessSpareAdjustmentVoucherReport) {
      menu.AssetMovement = menu.AssetMovement || [];
      menuPermissions.AssetMovement = menuPermissions.AssetMovement || [];
      menuPermissions.AssetMovement = [...menuPermissions.AssetMovement, true];
      menu.AssetMovement.push(
        <Menu.Item key="SpareAdjustmentVouchers">
          <Link to="/spare-adjustment-vouchers">
            <Icon type="profile" style={{ color: '#08979c' }} />
            <span>Spare Adjustment Vouchers</span>
          </Link>
        </Menu.Item>
      );
    }

    // Spares Audit: static entry until the backend registers a 'SparesAudit'
    // module record. Once that record exists the module loop above places it,
    // so this block steps aside to avoid a duplicate menu item. Shown only when
    // the user's role has Spares Audit read permission (no super-admin shortcut).
    const sparesAuditModuleExists = modules.some(m => m && m.name === 'SparesAudit');
    const canAuditSpares = this.hasPermission(userAccess, "SparesAudit", "r");
    if (canAuditSpares && !sparesAuditModuleExists) {
      menu.AssetMovement = menu.AssetMovement || [];
      menuPermissions.AssetMovement = menuPermissions.AssetMovement || [];
      menuPermissions.AssetMovement = [...menuPermissions.AssetMovement, true];
      menu.AssetMovement.push(
        <Menu.Item key="SparesAudit">
          <Link to="/spares-audit">
            <Icon type="file-done" style={{ color: '#389e0d' }} />
            <span>Spares Audit</span>
          </Link>
        </Menu.Item>
      );
    }

    const canManageAssetSpeedLimit = this.hasPermission(userAccess, "Asset", "u");
    if (canManageAssetSpeedLimit) {
      menu.AssetMaintenance = menu.AssetMaintenance || [];
      menuPermissions.AssetMaintenance = menuPermissions.AssetMaintenance || [];
      menuPermissions.AssetMaintenance = [...menuPermissions.AssetMaintenance, true];
      menu.AssetMaintenance.push(
        <Menu.Item key="Asset/SpeedLimit">
          <Link to="/asset/speed-limit">
            <Icon type="dashboard" style={{ color: '#2f54eb' }} />
            <span>Speed Limit</span>
          </Link>
        </Menu.Item>
      );

      menu.AssetMovement = menu.AssetMovement || [];
      menuPermissions.AssetMovement = menuPermissions.AssetMovement || [];
      menuPermissions.AssetMovement = [...menuPermissions.AssetMovement, true];
      menu.AssetMovement.push(
        <Menu.Item key="Asset/BulkAssetUpdate">
          <Link to="/asset/bulk-asset-update">
            <Icon type="upload" style={{ color: '#13c2c2' }} />
            <span>Bulk Asset Update</span>
          </Link>
        </Menu.Item>
      );
    }

    // Asset Reclassification sits under Masters: it rewrites the asset taxonomy
    // (categories, types, sub-types, makes, models) and re-points assets onto it.
    // A static entry because the menu is otherwise built from module records and
    // no 'AssetReclassification' module exists server-side yet; when one is added
    // this block can go and the module will place itself.
    //
    // Gated on update rights over AssetModel, which is what the tool actually
    // writes - not on Asset, so it cannot be reached by someone who may only
    // edit assets.
    const canReclassify = this.hasPermission(userAccess, "AssetModel", "u");
    if (canReclassify) {
      menu.Masters = menu.Masters || [];
      menuPermissions.Masters = menuPermissions.Masters || [];
      menuPermissions.Masters = [...menuPermissions.Masters, true];
      menu.Masters.push(
        <Menu.Item key="AssetReclassification">
          <Link to="/asset-reclassification">
            <Icon type="apartment" style={{ color: '#531dab' }} />
            <span>Asset Reclassification</span>
          </Link>
        </Menu.Item>
      );
    }

    const canAccessPointOfInterest = !!(
      authUser && (
        authUser.superAdmin
        || (permittedModules.includes("Telematics") && this.hasPermission(userAccess, 'PointOfInterest', 'any'))
      )
    );
    if (canAccessPointOfInterest) {
      menu.SecurityAndControl = menu.SecurityAndControl || [];
      menuPermissions.SecurityAndControl = menuPermissions.SecurityAndControl || [];
      menuPermissions.SecurityAndControl = [...menuPermissions.SecurityAndControl, true];
      // menu.SecurityAndControl.push(
      //   <Menu.Item key="GeoFence">
      //     <Link to="/geo-fence">
      //       <Icon type="environment" style={{ color: '#13c2c2' }} />
      //       <span>Points of Interest</span>
      //     </Link>
      //   </Menu.Item>
      // );
      menu.SecurityAndControl.push(
        <Menu.Item key="GeoFenceImport">
          <Link to="/geo-fence/import">
            <Icon type="upload" style={{ color: '#fa8c16' }} />
            <span>POI GeoJSON Import</span>
          </Link>
        </Menu.Item>
      );
      menu.SecurityAndControl.push(
        <Menu.Item key="PoiManager">
          <Link to="/poi-manager">
            <Icon type="layout" style={{ color: '#722ed1' }} />
            <span>POI Map Manager</span>
          </Link>
        </Menu.Item>
      );
    }

    if (authUser && authUser.superAdmin) {
      menu.DataImport = menu.DataImport || [];
      menuPermissions.DataImport = menuPermissions.DataImport || [];
      menuPermissions.DataImport = [...menuPermissions.DataImport, true];
      menu.DataImport.push(
        <Menu.Item key="DailyFuelProcessReportNotification">
          <Link to="/daily-fuel-process-report-notification">
            <Icon type="notification" style={{ color: '#cf1322' }} />
            <span>Daily Fuel Report Notification</span>
          </Link>
        </Menu.Item>
      );
    }

    if (authUser && authUser.superAdmin) {
      menu.BillingUnits = menu.BillingUnits || [];
      menuPermissions.BillingUnits = menuPermissions.BillingUnits || [];
      menuPermissions.BillingUnits = [...menuPermissions.BillingUnits, true];
      menu.BillingUnits.push(
        <Menu.Item key="BillingUnits">
          <Link to="/billing-units">
            <Icon type="account-book" style={{ color: '#389e0d' }} />
            <span>Billing Units</span>
          </Link>
        </Menu.Item>
      );
    }

    return (
      <Auxiliary>
        <SidebarLogo authUser={authUser} />
        <div className="gx-sidebar-content">
          <CustomScrollbars className="gx-layout-sider-scrollbar">
            <Menu
              defaultOpenKeys={[defaultOpenKeys]}
              selectedKeys={[selectedKeys]}
              theme={themeType === THEME_TYPE_LITE ? "lite" : "dark"}
              mode="inline"
            >
              {this.state.favourite && this.state.favourite.length ?
                <SubMenu
                  key={"Favourite"}
                  title={
                    <span>
                      <i className="icon icon-star" style={{ color: 'tomato' }} />
                      <span>Favourite</span>
                    </span>
                  }>
                  {
                    (this.state.favourite || []).map((fav, index) => (
                      <Menu.Item key={fav.module + index}>
                        <AccessControl
                          permissionNeeded={"any"}
                          resource={fav.module.substring(4, fav.module.length)}
                          roles={authUser ? authUser.roles : []}
                          key={fav.module}
                          render={props => {
                            return <Link to={`/${fav.link}`}>
                              {this.renderModuleIcon(fav.module.substring(4, fav.module.length))}
                              <Tooltip mouseEnterDelay={1} title={(<i
                                className={`icon icon-star-o`}
                                style={{ cursor: 'pointer' }}
                                // onMouseEnter={() => this.onMouseHoverHandler(fav.module, true)}
                                // onMouseLeave={() => this.onMouseHoverHandler(fav.module, false)}
                                onClick={() => this.handleFavourite({
                                  module: fav.module,
                                  name: fav.name,
                                  link: fav.link
                                }, false)} />)}>
                                <span>{fav.name}</span>
                              </Tooltip>
                            </Link>
                          }} />
                      </Menu.Item>))
                  }
                </SubMenu> : null}

              <SubMenu
                key={"Home"}
                title={
                  <span>
                    {this.renderModuleIcon('Home', { fontSize: '18px', marginTop: '10px' })}
                    <span>Home</span>
                  </span>
                }
              >
                <Menu.Item key="dashboard">
                  <Link to="/dashboard">
                    {this.renderModuleIcon('Dashboard')}
                    <IntlMessages id="sidebar.dashboard" />
                  </Link>
                </Menu.Item>
              </SubMenu>

              {
                Object.keys(menu).map(parent => {
                  const isOk = (menuPermissions[parent] || []).reduce((accumulator, currentValue) => accumulator || currentValue, false);
                  // console.log(menu, parent, isOk)
                  if (parent !== "Internal" && isOk) {
                    return (
                      <SubMenu
                        key={parent}
                        title={
                          <span>
                            {this.renderModuleIcon(parent, { fontSize: '18px', marginTop: '10px' })}
                            <span>{sanitizeFieldName(parent)}</span>
                          </span>
                        }
                      >
                        {menu[parent]}
                      </SubMenu>
                    );
                  }
                })}
              {authUser && !authUser.superAdmin && (
                <SubMenu
                  key={"Report"}
                  title={
                    <span>
                      {this.renderModuleIcon('Report', { fontSize: '18px', marginTop: '10px' })}
                      <span>Report</span>
                    </span>
                  }
                >
                  {this.hasPermission(userAccess, "Asset", "report") &&
                    <Menu.Item key="Asset/report">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-Asset',
                          name: 'Asset Availability Report',
                          link: "asset/report"
                        }, true)} />)}>
                        <Link to="/asset/report">
                          {this.renderModuleIcon('Asset')}
                          {/*Asset Report*/}
                          <span>Asset Availability Report</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }
                  {this.hasPermission(userAccess, "PurchaseOrder", "r") &&
                    <Menu.Item key="PurchaseOrder/assetPurchaseReport">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-PurchaseOrder',
                          name: 'Asset Purchase Report',
                          link: "purchase-order/asset-purchase-report"
                        }, true)} />)}>
                        <Link to="/purchase-order/asset-purchase-report">
                          {this.renderModuleIcon('PurchaseOrder')}
                          {/*Asset Report*/}
                          <span>Asset Purchase Report</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }
                  {this.hasPermission(userAccess, "Asset", "report") &&
                    <Menu.Item key="Asset/spareReport">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-Asset',
                          name: 'Asset Spare Report',
                          link: "asset/spare-report"
                        }, true)} />)}>
                        <Link to="/asset/spare-report">
                          {this.renderModuleIcon('SparePart')}
                          {/*Asset Report*/}
                          <span>Asset Spare Report</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }
                  {this.hasPermission(userAccess, "Asset", "report") &&
                    <Menu.Item key="Asset/spareIssueReport">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-Asset',
                          name: 'Spare Issue Report',
                          link: "asset/spare-issue-report"
                        }, true)} />)}>
                        <Link to="/asset/spare-issue-report">
                          <Icon type="tool" style={{ color: '#fa541c' }} />
                          <span>Spare Issue Report</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }
                  {this.hasPermission(userAccess, "Complaint", "report") &&
                    <Menu.Item key="Complaint/assetUnserviceableReport">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-Complaint',
                          name: 'complaint/asset-unserviceable-report',
                          link: "asset/spare-issue-report"
                        }, true)} />)}>
                        <Link to="/complaint/asset-unserviceable-report">
                          {this.renderModuleIcon('Complaint')}
                          <span>Asset Unserviceable Report</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }
                  {this.hasPermission(userAccess, "JobCard", "r") &&
                    <Menu.Item key="JobCard/costingReport">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-JobCard',
                          name: 'Job Card Costing Report',
                          link: "job-card/costing-report"
                        }, true)} />)}>
                        <Link to="/job-card/costing-report">
                          {this.renderModuleIcon('JobCard')}
                          {/* <span style={{ marginRight: '15px', fontSize: '16px', fontWeight: 'bold' }}>₹</span> */}
                          {/*Asset Report*/}
                          <span>Asset Maintenance Cost Report</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }
                  {this.hasPermission(userAccess, "AssetStockTaking", "report") &&
                    <Menu.Item key="AssetStockTaking/report">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-AssetStockTaking',
                          name: 'Asset Stock Taking',
                          link: "asset-stock-taking/report"
                        }, true)} />)}>
                        <Link to="/asset-stock-taking/report">
                          {this.renderModuleIcon('AssetStockTaking')}
                          <span>Asset Stock Taking</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }
                  {this.hasPermission(userAccess, "PreVerification", "report") &&
                    <Menu.Item key="PreVerification/report">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-PreVerification',
                          name: 'Pre Verification',
                          link: "pre-verification/report"
                        }, true)} />)}>
                        <Link to="/pre-verification/report">
                          {this.renderModuleIcon('PreVerification')}
                          <span>Pre Verification</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }
                  {this.hasPermission(userAccess, "ManpowerPerformance", "report") &&
                    <Menu.Item key="ManpowerPerformance/report">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-ManpowerPerformance',
                          name: 'Manpower Performance Report',
                          link: "manpower-performance/report"
                        }, true)} />)}>
                        <Link to="/manpower-performance/report">
                          {this.renderModuleIcon('ManpowerPerformance')}
                          <span>Manpower Performance Report</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }
                  {this.hasPermission(userAccess, "Document", "report") &&
                    <Menu.Item key="Document/report">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-Document',
                          name: 'Asset Document Report',
                          link: "document/report"
                        }, true)} />)}>
                        <Link to="/document/report">
                          {this.renderModuleIcon('Document')}
                          <span>Asset Document Report</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }
                  {this.hasPermission(userAccess, "SaleOrder", "report") &&
                    <Menu.Item key="SaleOrder/sales-report">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-SaleOrder',
                          name: 'Sales Report',
                          link: "sale-order/sales-report"
                        }, true)} />)}>
                        <Link to="/sale-order/sales-report">
                          {this.renderModuleIcon('SaleOrder')}
                          <span>Sales Report</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }
                  {/*Jay*/}
                  {this.props.authUser && this.props.authUser.roles && this.props.authUser.roles.find(item => item && item.spareInventoryReport === true) &&
                    this.hasPermission(userAccess, "SparePart", "report") &&
                    <Menu.Item key="SpareInventoryReport">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-SparePart',
                          name: 'Spare Inventory Report',
                          link: "spare-inventory-report"
                        }, true)} />)}>
                        <Link to="/spare-inventory-report" style={{ color: '#038FDE' }}>
                          {this.renderModuleIcon('Inventory')}
                          <span>Spare Inventory Report</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }
                  {this.hasPermission(userAccess, "Fuel", "report") &&
                    <Menu.Item key="Fuel/mileage-report">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-Fuel',
                          name: 'Fuel Consp. Rate',
                          link: "fuel/mileage-report"
                        }, true)} />)}>
                        <Link to="/fuel/mileage-report">
                          {this.renderModuleIcon('Fuel')}
                          <span>Fuel Consp. Rate</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }
                  {this.hasPermission(userAccess, "Fuel", "report") &&
                    <Menu.Item key="Fuel/fuel-group-chart">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-Fuel',
                          name: 'Fuel Group Chart',
                          link: "fuel/fuel-group-chart"
                        }, true)} />)}>
                        <Link to="/fuel/fuel-group-chart">
                          <Icon type="bar-chart" style={{ color: '#08979c' }} />
                          <span>Fuel Group Chart</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }
                  {this.hasPermission(userAccess, "Fuel", "report") &&
                    <Menu.Item key="Fuel/summery-report">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-Fuel',
                          name: 'Location-wise Fuel Consp.',
                          link: "fuel/summery-report"
                        }, true)} />)}>
                        <Link to="/fuel/summery-report">
                          <Icon type="environment" style={{ color: '#13c2c2' }} />
                          <span>Location-wise Fuel Consp.</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }
                  {this.hasPermission(userAccess, "Fuel", "report") &&
                    <Menu.Item key="Fuel/refuel-report">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-Fuel',
                          name: 'Fuel Reconciliation Report',
                          link: "fuel/refuel-report"
                        }, true)} />)}>
                        <Link to="/fuel/refuel-report">
                          <Icon type="reload" style={{ color: '#fa8c16' }} />
                          <span>Fuel Reconciliation Report</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }
                  {this.hasPermission(userAccess, "Fuel", "report") &&
                    <Menu.Item key="Fuel/bowser-report">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-Fuel',
                          name: 'Bowser Report',
                          link: "fuel/bowser-report"
                        }, true)} />)}>
                        <Link to="/fuel/bowser-report">
                          <Icon type="api" style={{ color: '#722ed1' }} />
                          <span>Bowser Report</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }
                  {this.hasPermission(userAccess, "Fuel", "report") &&
                    <Menu.Item key="Fuel/stock-issue-report">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-Fuel',
                          name: 'Fuel Stock & Issue Report',
                          link: "fuel/stock-issue-report"
                        }, true)} />)}>
                        <Link to="/fuel/stock-issue-report">
                          <Icon type="database" style={{ color: '#eb2f96' }} />
                          <span>Fuel Stock & Issue Report</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }

                  {permittedModules.includes("Telematics") && this.hasPermission(userAccess, "Fuel", "report") &&
                    <Menu.Item key="IotDevice/daily-iot-report">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-Fuel',
                          name: 'Daily IOT Device Report',
                          link: "iot/daily-iot-report"
                        }, true)} />)}>
                        <Link to="/iot/daily-iot-report">
                          <Icon type="file-pdf" style={{ color: '#cf1322' }} />
                          <span>Daily IOT Device Report</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }

                  {permittedModules.includes("Telematics") && this.hasPermission(userAccess, "Fuel", "report") &&
                    <Menu.Item key="IotDevice/tickets-report">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-Fuel',
                          name: 'IoT Tickets Report',
                          link: "iot/tickets-report"
                        }, true)} />)}>
                        <Link to="/iot/tickets-report">
                          <Icon type="tags" style={{ color: '#fa8c16' }} />
                          <span>IoT Tickets Report</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }

                  {permittedModules.includes("Telematics") && this.hasPermission(userAccess, "Fuel", "report") &&
                    <Menu.Item key="IotDevice/iot-device-report">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-Fuel',
                          name: 'Iot Device Report',
                          link: "iot/iot-device-report"
                        }, true)} />)}>
                        <Link to="/iot/iot-device-report">
                          {this.renderModuleIcon('IotDevice')}
                          <span>Iot Device Report</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }

                  {permittedModules.includes("Telematics") && this.hasPermission(userAccess, "Fuel", "report") &&
                    <Menu.Item key="IotDevice/iot-daily-process-check">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-Fuel',
                          name: 'Iot Daily Process Check',
                          link: "iot/iot-daily-process-check"
                        }, true)} />)}>
                        <Link to="/iot/iot-daily-process-check">
                          <Icon type="check-circle" style={{ color: '#52c41a' }} />
                          <span>Iot Daily Process Check</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }
                  {this.hasRoleName(authUser.roles, "IOT-SUPPORT-#1") &&
                    <Menu.Item key="iot-support-jobs">
                      <Tooltip title={(<i
                        className={`icon icon-dashboard`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-IotDevice',
                          name: 'Iot Support Jobs',
                          link: "iot-support-jobs"
                        }, true)} />)}>
                        <Link to="/iot-support-jobs">
                          {this.renderModuleIcon('IotSupportJobs')}
                          <span>Iot Support Jobs</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }

                  {this.hasPermission(userAccess, "Leasing", "report") &&
                    <Menu.Item key="Leasing/revenueReport">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-Leasing',
                          name: 'Leasing Revenue Report',
                          link: "leasing/revenue-report"
                        }, true)} />)}>
                        <Link to="/leasing/revenue-report">
                          {this.renderModuleIcon('Leasing')}
                          <span>Leasing Revenue Report</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }
                  {this.hasPermission(userAccess, "Leasing", "report") &&
                    <Menu.Item key="Leasing/calculation">
                      <Tooltip title={(<i
                        className={`icon icon-star`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleFavourite({
                          module: 'FAV-Leasing',
                          name: 'Leasing Calculation Report',
                          link: "leasing/calculation"
                        }, true)} />)}>
                        <Link to="/leasing/calculation">
                          <Icon type="read" theme="filled" style={{ color: '#237804' }} />
                          <span>Leasing Calculation Report</span>
                        </Link>
                      </Tooltip>
                    </Menu.Item>
                  }
                </SubMenu>
              )}
            </Menu>
          </CustomScrollbars>
        </div>
        <div style={{ display: process.env.REACT_APP_ENVIRONMENT === 'production' ? 'none' : 'block' }}>
          <Card size={'small'} bordered={false} style={{ background: 'transparent', marginRight: '5px' }}>
            <p style={{ paddingLeft: '10px' }}>Last updated on : {app.apiLastDate}</p>
            <p>API : <Tag color="cyan">v{app.apiVersion}</Tag><Tag color="cyan">{app.apiBranch}</Tag></p>

            {(process.env.REACT_APP_ENVIRONMENT !== 'production') ?
              <div className="waviy" style={{
                width: '100%', textAlign: 'center', marginTop: '0px'
              }}>
                <span style={{ fontSize: '18px', fontWeight: 'bold' }}>DEMO APP</span>
              </div> : null}
          </Card>
        </div>
        <div style={{ display: process.env.REACT_APP_ENVIRONMENT === 'production' ? 'block' : 'none' }}>
          <Card size={'small'} bordered={false} style={{ background: 'transparent', marginRight: '5px' }}>
            <p style={{ paddingLeft: '10px' }}>Last updated on : {app.apiLastDate}</p>
          </Card>
        </div>
      </Auxiliary>
    );
  }
}

SidebarContent.propTypes = {};
const mapStateToProps = ({ auth, settings }) => {
  const { navStyle, themeType, locale, pathname, app } = settings;
  const { authUser } = auth;
  return { navStyle, themeType, locale, pathname, authUser, app };
};

function mapDispatchToProps(dispatch) {
  return {
    fetchAppVersion
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(SidebarContent);
